import { BankRegistrationGuide } from './BankRegistrationGuide';
import {
  SHINHAN_COMPLETE_REGISTRATION_STEPS,
  SHINHAN_NOTIFY_OPTIONS,
  SHINHAN_REQUEST_CODE_STEPS,
} from './shinhanGuide';
import { GATEWAY_NUMBER_DISPLAY } from './wooriGuide';

interface Props {
  authCode: string | null;
  codeRemainingSec: number | null;
  registered: boolean;
  onCancel: () => void;
  onComplete: () => void;
}

export function ShinhanRegistrationGuide(props: Props) {
  return (
    <BankRegistrationGuide
      {...props}
      bankAppLabel="신한 SOL뱅크"
      authCodeLength={6}
      requestCodeSteps={SHINHAN_REQUEST_CODE_STEPS}
      completeRegistrationSteps={SHINHAN_COMPLETE_REGISTRATION_STEPS}
      notifyOptions={SHINHAN_NOTIFY_OPTIONS}
      awaitingCodeMessage="5단계에서 [인증요청]을 누르면 이곳에 자동으로 표시돼요."
      gatewayNumber={GATEWAY_NUMBER_DISPLAY}
    />
  );
}
